import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=c92475e8"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=c92475e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports